import './src/styles/global.css'
import "@fontsource/montserrat/800.css"
import "@fontsource/montserrat"
import "@fontsource/inter/400.css"
import "@fontsource/inter/500.css"
import "@fontsource/inter/600.css"
import "@fontsource/inter/700.css"
import "@fontsource/inter/800.css"
import "@fontsource/manrope/400.css"
import "@fontsource/manrope/500.css"
import "@fontsource/manrope/600.css"
import "@fontsource/manrope/700.css"
import "@fontsource/manrope/800.css"
import "typeface-nunito-sans";
import React from 'react';
import { GlobalStateProvider } from './src/components/general/globalState';
import { Analytics } from "@vercel/analytics/react";
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';

// Desabilitar a injeção automática de CSS do Font Awesome
// Isso previne o FOUC (Flash of Unstyled Content)
config.autoAddCss = false;

export const onClientEntry = () => {
  if (typeof document !== 'undefined') {
    document.documentElement.classList.add('notranslate');
    document.body.classList.add('notranslate');
    document.documentElement.setAttribute('translate', 'no');
    document.body.setAttribute('translate', 'no');
    
    // Keep <html lang> consistent during client-side navigation (SSR sets the initial value)
    const pathname = window.location.pathname;
    const langMatch = pathname.match(/^\/([a-z]{2})(\/|$)/);
    const detectedLang = langMatch ? langMatch[1] : 'en';
    
    const langMap = {
      'en': 'en', 'es': 'es', 'fr': 'fr', 'de': 'de', 'it': 'it',
      'pt': 'pt', 'nl': 'nl', 'pl': 'pl', 'ru': 'ru', 'zh': 'zh',
      'ja': 'ja', 'ko': 'ko', 'ar': 'ar', 'th': 'th', 'vi': 'vi'
    };
    
    const finalLang = langMap[detectedLang] || 'en';
    document.documentElement.setAttribute('lang', finalLang);

    // Initialize Crisp on all pages (client-side only)
    if (typeof window !== 'undefined') {
      window.$crisp = window.$crisp || [];
      window.CRISP_WEBSITE_ID = "1d18c1ed-3e63-44cc-b27e-76d477d0ccfd";
      if (!document.getElementById('crisp-chat')) {
        const s = document.createElement('script');
        s.id = 'crisp-chat';
        s.src = 'https://client.crisp.chat/l.js';
        s.async = true;
        document.getElementsByTagName('head')[0].appendChild(s);
      }
    }
  }
}

// Update lang on route changes (client-side navigation)
// This ensures lang is correct during SPA navigation, but SSR sets the initial value
export const onRouteUpdate = ({ location }) => {
  if (typeof document !== 'undefined') {
    const pathname = location.pathname;
    const langMatch = pathname.match(/^\/([a-z]{2})(\/|$)/);
    const detectedLang = langMatch ? langMatch[1] : 'en';
    
    const langMap = {
      'en': 'en', 'es': 'es', 'fr': 'fr', 'de': 'de', 'it': 'it',
      'pt': 'pt', 'nl': 'nl', 'pl': 'pl', 'ru': 'ru', 'zh': 'zh',
      'ja': 'ja', 'ko': 'ko', 'ar': 'ar', 'th': 'th', 'vi': 'vi'
    };
    
    const finalLang = langMap[detectedLang] || 'en';
    document.documentElement.setAttribute('lang', finalLang);
  }
}


export const wrapRootElement = ({ element }) => {
  return (
    <GlobalStateProvider>
      {element}
      <Analytics />
    </GlobalStateProvider>
  );
};


